import axios from 'axios';
import { Dispatch } from 'redux';
import { LocationsAction, LocationsActionTypes } from '../../types/locations';
import { errorHandler } from '../../utils/service';
import { setAlert } from './alert';

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
};

export const getLocations =
  () => async (dispatch: Dispatch<LocationsAction | any>) => {
    try {
      dispatch({
        type: LocationsActionTypes.SET_LOCATIONS_LOADING,
        payload: true
      });

      const res = await axios.get('/api/locations', config);
      dispatch({
        type: LocationsActionTypes.GET_LOCATIONS,
        payload: res.data
      });
    } catch (error: any) {
      errorHandler({ error, dispatch, setAlert });
      dispatch({
        type: LocationsActionTypes.SET_LOCATIONS_LOADING,
        payload: false
      });
    }
  };

export const setSelectedLocations =
  (locations: any) => (dispatch: Dispatch<LocationsAction>) => {
    dispatch({
      type: LocationsActionTypes.SET_SELECTED_LOCATIONS,
      payload: locations
    });
  };
